import React from 'react';
import { Button } from 'reactstrap';
import * as Icon from 'react-feather';

const SessionBlocked = () => {
  return (
    <div className="d-flex align-items-center justify-content-center vh-100 bg-light">
      <div
        className="text-center p-5 shadow-sm rounded bg-white"
        style={{ maxWidth: '480px', width: '100%' }}>
        <div className="mb-4">
          <Icon.AlertTriangle size={64} className="text-warning" />
        </div>

        <h4 className="fw-semibold mb-3">Active Session Detected</h4>

        <p className="text-muted mb-2">An active session is already running in another tab.</p>

        <p className="text-muted mb-4">
          Running multiple tabs may cause call interruptions, duplicate actions, or data
          inconsistencies.
        </p>

        <div className="d-grid gap-2">
          <Button color="primary" size="lg" onClick={() => window.location.reload()}>
            Retry
          </Button>
        </div>
      </div>
    </div>
  );
};

export default SessionBlocked;
